import Layout from '@/container/Full'

const TicketList = () => import(/* webpackChunkName: "support" */ '../views/support/TicketsListView')
const TicketView = () => import(/* webpackChunkName: "support" */ './../views/support/TicketView')
const TicketNew = () => import(/* webpackChunkName: "support" */ './../views/support/TicketNewView')
const MigrationForm = () => import(/* webpackChunkName: "support" */ './../views/support/MigrationView')

const routes = [
  {
    path: '/support',
    component: Layout,
    meta: {
      breadcrumb: 'Support',
      pageTitle: 'Support',
    },
    children: [
      {
        path: 'migration',
        name: 'migration_request',
        component: MigrationForm,
        meta: {
          breadcrumb: 'Migration Request',
          pageTitle: 'Migration Request',
          access_type: 'authorized'
        },
      },
      {
        path: '',
        name: 'support_ticketlist',
        component: TicketList,
        meta: {
          access_type: 'authorized',
          pageTitle: 'Support',
        }
      },
      {
        path: 'ticket/:ticketid',
        name: 'ticket_view',
        component: TicketView,
        props: true,
        meta: {
          breadcrumb: routeParams => `Ticket ${routeParams.ticketid}`,
          pageTitle: 'Support',
          access_type: 'authorized'
        },
      },
      {
        path: 'open-ticket',
        name: 'support_ticketnew',
        component: TicketNew,
        meta: {
          breadcrumb: 'Open Ticket',
          pageTitle: 'Open Ticket',
          access_type: 'authorized'
        },
      },
    ]
  }
]

export default routes
